const MESSAGE_STARTS_WITH = 'Validation Errors! \n';

export const FORMAT_ERROR_MESSAGE = (validationErrors) => {
    let errors = validationErrors;
    let message = '<h4>' + MESSAGE_STARTS_WITH + '</h4>';
    for (const key in errors) {
        message += '<p><b>' + key + '</b>' + ': ' + errors[key] + '</p>' + "\r\n"
    }

    return message
}
